import * as ng from 'angular';
import { UibDatepickerPopupFormat } from './uib-datepicker-popup-format.directive';


export const UibDatepickerPopupFormatModule: string =
    ng.module('uib-datepicker-popup-format', [
    ])
        .directive('uibDatepickerPopupFormat', UibDatepickerPopupFormat)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/uib-datepicker-popup-format/uib-datepicker-popup-format.module.ts